import React from "react";
import { useCharacter } from "../../../hooks/use-character";
import Field from "../../ui/Field";

interface Props {
  className?: string;
}

const Body: React.FC<Props> = ({ className }) => {
  const {
    mode,
    handleBodyChange,
    character: {
      body: { eyes },
    },
  } = useCharacter();

  return (
    <div className={`space-y-8 ${className}`}>
      {/** Eyes */}
      <Field
        label="Culoarea Ochilor"
        description="test"
        type="stepper"
        initialValue={eyes}
        min={1}
        max={32}
        onChange={(value) => handleBodyChange({ eyes: Number(value) })}
      />
    </div>
  );
};

export default Body;
